import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';

import { formatPriceWithCurrency } from '~/utils/formaters';

import { Props } from './interfaces';

const Price = ({
  price,
  discount,
  className,
  classNameOldPrice,
  classNameCurrentPrice,
}: Props) => {
  const priceText = formatPriceWithCurrency(price);

  return (
    <div className={classes(['price', className])}>
      {discount && (
        <p className={classes(['price__old', classNameOldPrice])}>
          {formatPriceWithCurrency(discount)}
        </p>
      )}
      <p
        className={classes([
          'price__current',
          discount && 'price__discount',
          classNameCurrentPrice,
        ])}
      >
        {priceText}
      </p>
    </div>
  );
};

export default observer(Price);
